module.exports = __webpack_public_path__ + "static/media/4.2-extra-assistentie.b7dd0b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/03/assets/4.2-extra-assistentie.jpg
// module id = 475
// module chunks = 0